import {EMMAI_FORMS} from '../../../../../const';

export default function usePractitionerNavigation({setCurrentForm, setIsPractitionerUpdating}) {
  const goToPractitionerActivity = () => {
    setCurrentForm(EMMAI_FORMS.OFFICE_AND_PRACTITIONER_ACTIVITY);
    setIsPractitionerUpdating(false);
  };

  const goToAddPractitioner = () => {
    setCurrentForm(EMMAI_FORMS.ADD_OR_UPDATE_PRACTITIONER);
    setIsPractitionerUpdating(false);
  };

  return {
    goToPractitionerActivity,
    goToAddPractitioner
  };
}
